/* global AP */

import React, { Component } from 'react';
import Button from '@atlaskit/button';
/**
 * The status to wait on for ScriptRunner to process values.
 */
const statusName = "Pre-process";
const timeout = 500; // Milliseconds
const viewRequestTypeId = "1137"; //The ID for the "View Users" request type
const userPermissionsRequestTypeID = "1170"; // the ID for the "User Permissions & Data Scoping" request type

/**
 * Open the UAMC using the hidden form in the HTML.
 */
const openUAMC = async () => {
  try {
    document.getElementById('uamcForm').submit();
  } catch (error) {
    console.error("Unable to open UAMC.");
  }
}

/**
 * Dynamically fill in the form with the relevant information .
 */
const updateForm = async () => {

  const form = document.getElementById('uamcForm');

  // REST calls to get the Jira objects
  const issueId = await getIssueId();

  // Update work item id
  form.WorkItemId.value = issueId;
}

/**
 * Uses the Atlassian Javascript API to get the context.
 */
const getContext = async () => {
  const response = await new Promise(resolve => {
    AP.context.getContext(resolve);
  });
  return response;
}

/**
 * Get the issue id for the request.
 */
const getIssueId = async () => {
  const context = await getContext();
  return context.jira.issue.id;
}

/**
 * Get the request type for the context.
 */
const getRequestTypeId = async () => {
  const issueId = await getIssueId();
  const request = await getRequest(issueId);
  return request.requestTypeId;
}

/**
 * Get the customer request.
 */
const getRequest = async (issueId) => {
  const response = await AP.request(`/rest/servicedeskapi/request/${issueId}`);
  const request = JSON.parse(response.body);
  return request;
}

/**
 * Determine if the 'created' query string parameter is 'true'.
 */
const isRequestCreated = async () => {
  const location = await new Promise(resolve => {
    AP.getLocation(resolve);
  });
  const url = new URL(location);
  const queryStringParameters = new URLSearchParams(url.search);

  return queryStringParameters.get('created') === 'true';
}

const waitForPreProcess = async () => {
  const issueId = await getIssueId();

  let isPreProcessStatus;
  do {
    // Get request
    const request = await getRequest(issueId);
    // Values exist
    isPreProcessStatus = request.currentStatus.status === statusName;
    // If still in pre-process stage, wait
    isPreProcessStatus && await waitMilliseconds(timeout);

  } while (isPreProcessStatus);
}

const waitMilliseconds = async (milliseconds) => {
  await new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export default class RequestPanel extends Component {

  state = { 
    requestFieldValuesExist: false,
    buttonLabel: '',
  }

  componentDidMount = async () => {
    // Determine if we are viewing or editing
    const issueId = await getIssueId();
    const requestTypeId = await getRequestTypeId();
    const request = await getRequest(issueId);
    //inital button label if it loads will be "Open UAMC"
    let buttonLabel = "Open UAMC"; 
    //if the current status is paused and the request type is Users and Data Scoping set label to be "Re-open UAMC"
    if ((request.currentStatus.status === "Paused") && (requestTypeId === userPermissionsRequestTypeID)){ 
      buttonLabel = "Re-open UAMC"
    }
    //if the request type is "view users" set lavel to be "View UAMC"
    else if(requestTypeId === viewRequestTypeId){ 
      buttonLabel = "View UAMC"
    }
    this.setState({ buttonLabel });

    // Wait for pre-processing to happen
    await waitForPreProcess();
    this.setState({ requestFieldValuesExist: true })

    try {
      await updateForm();
    } catch (error) {
      console.error("Unable to get UAMC fields." + error);
    }

    // Open UAMC if newly created
    const created = await isRequestCreated();
    if (created) {
      openUAMC();
    }
  }

  render() {
    const { requestFieldValuesExist, buttonLabel } = this.state;
    const isLoading = !buttonLabel || !requestFieldValuesExist;

    return (
      <>
        <div style={{ padding: '4px 4px' }}>
            <Button
              appearance={!isLoading && "primary"}
              onClick={openUAMC}
              isLoading={isLoading}
            >{buttonLabel}</Button>
        </div>
      </>
    )
  }
}
